// extracted by mini-css-extract-plugin
export default {"isDragging":"draggable-phase-tabs_isDragging__l1eCF","isDragOver":"draggable-phase-tabs_isDragOver__2JzKN","handle":"draggable-phase-tabs_handle__UBPvW"};